module.exports = __webpack_public_path__ + "media/images/DSC_3465-69b39254e996d9e863dbe8d18decb076.jpg";